<div class="main">
  <dx-data-grid
    [dataSource]="detailsDataSource"
    [showBorders]="true"
    [columnAutoWidth]="true"
    [width]="'70%'">
    <dxi-column dataField="reportSubType" caption="Report Name"></dxi-column>
    <dxi-column dataField="status" caption="Status"></dxi-column>
    <dxi-column dataField="lastUpdateDateTime" caption="Last Update Date/Time" dataType="datetime"></dxi-column>        
  </dx-data-grid>
  <div class="refresh" [hidden]="false">
      <dx-button *ngIf="showRefreshButton" text="Refresh Status" 
        stylingMode="contained" type="default" (onClick)="refresh()"
        [elementAttr]="{class: 'right-margin'}">
      </dx-button>
    <!-- <dx-button text="View Reports" stylingMode="contained" type="default" (onClick)="onViewReportClicked()"></dx-button> -->
  </div>

</div>
